// The install step's note for a solution's page at its own origin (02-DESIGN/
// 09-gateway/02-the-oauth-face.md § a solution's page at its own origin): the
// origin to register as a redirect on the sign-in provider's native client,
// with its copy button. Drawn for an admin before Install and on the
// installed solution's Overview; nothing for a solution without such a page.

import { Notice, OnceValue } from "../../ui/components.tsx";
import type { Manifest } from "../../wire/solutions.ts";
import { pageRedirect } from "./words.ts";

export function PageRedirectNote({ m, workspace }: { m: Manifest; workspace: string }) {
  const r = pageRedirect(m, workspace);
  if (r === undefined) {
    return null;
  }
  return (
    <Notice kind="info" title={r.title}>
      <div className="stack">
        <p>{r.line}</p>
        <OnceValue label={r.label} value={r.origin} />
      </div>
    </Notice>
  );
}
